/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SystemPromptCreateRequestDto } from '../models/SystemPromptCreateRequestDto';
import type { SystemPromptResponseDto } from '../models/SystemPromptResponseDto';
import type { SystemPromptUpdateRequestDto } from '../models/SystemPromptUpdateRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemPromptApiService {
    /**
     * Get a particular system prompt
     * Fetches a system prompt
     * @param id
     * @returns SystemPromptResponseDto a system prompts
     * @throws ApiError
     */
    public static getSystemPrompt(
        id: string,
    ): CancelablePromise<SystemPromptResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/system-prompts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a system prompt
     * Updates a system prompt.
     * @param id
     * @param requestBody
     * @returns SystemPromptResponseDto System prompt is updated
     * @throws ApiError
     */
    public static updateSystemPrompt(
        id: string,
        requestBody: SystemPromptUpdateRequestDto,
    ): CancelablePromise<SystemPromptResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/system-prompts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a system prompt
     * Deletes a system prompt
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteSystemPrompt(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/system-prompts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all system prompts
     * Fetches a list of all system prompts
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @returns SystemPromptResponseDto List of system prompts
     * @throws ApiError
     */
    public static getSystemPrompts(
        page?: number,
        size: number = 100,
        sort?: Array<string>,
    ): CancelablePromise<Array<SystemPromptResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/system-prompts',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create a system prompt
     * Creates a system prompt.
     * @param requestBody
     * @returns SystemPromptResponseDto System prompt is created
     * @throws ApiError
     */
    public static createSystemPrompt(
        requestBody: SystemPromptCreateRequestDto,
    ): CancelablePromise<SystemPromptResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/system-prompts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Preview system prompt with substituted global system prompts
     * Substitutes global system prompts and return the whole system prompt
     * @param requestBody
     * @returns string Global system prompts substituted successfully
     * @throws ApiError
     */
    public static previewSystemPrompt(
        requestBody: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/system-prompts/preview',
            body: requestBody,
            mediaType: 'text/plain',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
